import { createFileRoute } from '@tanstack/react-router'

import { IrrigationDevicesScreen } from '@/components/irrigation/irrigation-devices-screen'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/irrigation-devices',
)({
    component: IrrigationDevicesPage,
})

/** Danh sách bộ phun nước SmartLab — chỉ xem, quyền irrigation.read. */
export function IrrigationDevicesPage() {
    const { hasPermission } = useAuth()
    if (!hasPermission('irrigation.read')) {
        return (
            <div className="p-8 text-center text-destructive">
                {m.common_permission_denied()}
            </div>
        )
    }
    return <IrrigationDevicesScreen />
}
